<template>

    <section>

        <div class="md_common-bl _padding-add">
            <div class="inner">

                <!-- ここから -->

                <!--LinkBtn - 追加 -->
                <Link class="btn_link md_icon-text _white" :href="route('admin.brand.dm.list')">
                    <div class="inner">
                        <span><div class="icon"><SvgIconAdd /></div>追加とかに使うボタン</span>
                    </div>
                </Link>

                <!--LinkBtn - ペンアイコン -->
                <Link class="btn_link md_icon-text _white" :href="route('admin.brand.dm.list')">
                    <div class="inner">
                        <span><div class="icon"><SvgIconEdit /></div>編集とかに使うボタン</span>
                    </div>
                </Link>

                <!--LinkBtn - 決定アイコン -->
                <Link class="btn_link md_icon-text _white" :href="route('admin.brand.dm.list')">
                    <div class="inner">
                        <span><div class="icon"><SvgIconCheck /></div>決定 / 保存とかに使うボタン</span>
                    </div>
                </Link>

                <!--LinkBtn - キャンセル -->
                <Link class="btn_link _cancel md_icon-text" :href="route('admin.brand.dm.list')">
                    <div class="inner">
                        <span><div class="icon"><SvgIconCancel /></div>キャンセルとかに使うボタン</span>
                    </div>
                </Link>

                <!-- ボタンを並ばせる場合 -->
                <h3 class="heading_component-s" style="margin-top: 2rem;">
                    <p class="main"><span>キャンセルボタンと並ばせる場合</span></p>
                    <p class="sub"><code>.btn_link-wrap</code>の中に並ばせるとキャンセルボタンと水平表示できる。</p>
                </h3>

                <!-- BtnLinkWrap -->
                <div class="btn_link-wrap">

                    <!--LinkBtn - キャンセル -->
                    <Link class="btn_link _cancel md_icon-text" :href="route('admin.brand.dm.list')">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCancel /></div>キャンセルとかに使うボタン</span>
                        </div>
                    </Link>

                    <!--LinkBtn - 決定アイコン -->
                    <Link class="btn_link md_icon-text _white" :href="route('admin.brand.dm.list')">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCheck /></div>決定 / 保存とかに使うボタン</span>
                        </div>
                    </Link>

                </div><!-- /.BtnLinkWrap -->

                <!-- ここまで -->

            </div><!--/.inner-->
        </div><!--/.md-common-bl-->

    </section>

</template>


<script>
    import { Link } from '@inertiajs/inertia-vue3'

    //Svg
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconAdd from '@/components/EndUser/svg/SvgIconAdd'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'
    import SvgIconImagePlace from '@/components/EndUser/svg/SvgIconImagePlace'
    import SvgIconMail from '@/components/EndUser/svg/SvgIconMail'
    import SvgIconChat from '@/components/EndUser/svg/SvgIconChat'
    import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'
    import SvgIconSend from '@/components/EndUser/svg/SvgIconSend'
    import SvgIconReload from '@/components/EndUser/svg/SvgIconReload'

    export default {
        components: {
            "Link": Link,
            //Svg
            SvgIconEdit,
            SvgIconCheck,
            SvgIconCancel,
            SvgIconBack,
            SvgIconDelete,
            SvgIconImagePlace,
            SvgIconMail,
            SvgIconChat,
            SvgIconSearch,
            SvgIconSend,
            SvgIconReload,
            SvgIconAdd
        },
    }
</script>
